/**
 * The one line a running tool shows — "Looking at Thursday…" — replaced by
 * the next, gone once the answer's text starts (`reduceTurn` clears it).
 *
 * A polite live region, so a screen reader hears each step without being
 * interrupted by it. The dot pulses only where motion is welcome
 * (`chat.css`); with reduced motion it simply sits there.
 */
export function Status({ label }: { label: string | null }) {
  if (!label) return null
  return (
    <p className="chat-status" role="status" aria-live="polite">
      <span className="chat-status__dot" aria-hidden="true" />
      {label}
    </p>
  )
}
